<template>
  <v-app>
    <v-content>
      <v-container fluid class="pa-0">
        <v-layout justify-center>
          <v-flex xs12 sm10 md8 lg6>
            <v-card flat class="pa-4 mt-4">

              <div class="text-xs-center mb-4">
                <img src="/img/swv-wien-logo.svg" alt="SWV Wien" style="max-height: 120px; max-width: 80%">
              </div>

              <div class="text-xs-center mb-4">
                <h1 class="headline font-weight-bold">EINLADUNG zum Informationsfrühstück</h1>
                <h2 class="title mt-1">2. Juni 2026</h2>
                <p class="subheading mt-2 grey--text text--darken-1">
                  U-Bahnbau / Einkaufsstraße Nussdorfer Straße / Grätzlparkplätze
                </p>
              </div>

              <v-divider class="mb-3" />

              <p>
                <strong>Ort:</strong> Café Nuss, Nussdorfer Straße 9, 1090 Wien<br>
                <strong>Zeit:</strong> 8:30 – 9:30 Uhr
              </p>

              <p>
                Der SWV-Alsergrund hält Sie im Rahmen seiner Veranstaltungen regelmäßig über
                Neuigkeiten und Entwicklungen im 9. Bezirk auf dem Laufenden.
                Wenn Sie Interesse an einem Informationsaustausch haben, senden wir Ihnen gerne
                unsere Einladungen zu.
              </p>

              <!-- Success -->
              <div v-if="done" class="text-xs-center py-4">
                <v-icon color="green" size="64" class="mb-3">check_circle</v-icon>
                <template v-if="auswahl === 'nicht_kuenftig'">
                  <h2 class="title mb-2">Vielen Dank für Ihre Rückmeldung!</h2>
                  <p class="grey--text">Wir halten Sie gerne über künftige Veranstaltungen am Laufenden.</p>
                </template>
                <template v-else>
                  <h2 class="title mb-2">Vielen Dank für Ihre Anmeldung!</h2>
                  <p class="grey--text">Wir freuen uns auf den gemeinsamen Austausch.</p>
                </template>
              </div>

              <!-- Form -->
              <template v-else>
                <v-divider class="mb-3" />

                <v-radio-group v-model="auswahl" :disabled="loading">
                  <v-radio
                    label="Ich komme gerne zum Informationsfrühstück am 2.6.2026"
                    value="komme"
                  />
                  <v-radio
                    label="Ich komme gerne zum Informationsfrühstück am 2.6.2026 und freue mich auch künftig über Ihre Einladungen."
                    value="komme_kuenftig"
                  />
                  <v-radio
                    label="Ich kann zum Informationsfrühstück am 2.6.2026 nicht kommen, freue mich aber künftig über Ihre Einladungen."
                    value="nicht_kuenftig"
                  />
                </v-radio-group>

                <v-text-field
                  v-model="name"
                  label="Name *"
                  outline
                  :rules="nameRules"
                  :disabled="loading"
                />

                <v-text-field
                  v-model="email"
                  label="E-Mail *"
                  outline
                  type="email"
                  :rules="emailRules"
                  :disabled="loading"
                />

                <v-text-field
                  v-model="telefon"
                  label="Telefon"
                  outline
                  type="tel"
                  :disabled="loading"
                />

                <p v-if="submitted && !auswahl" class="red--text body-1">
                  Bitte wählen Sie eine Option.
                </p>

                <p v-if="error" class="red--text body-1">
                  Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.
                </p>

                <v-btn
                  color="#e3010f"
                  dark
                  block
                  large
                  :loading="loading"
                  @click="submit"
                >
                  Absenden
                </v-btn>

                <p class="caption grey--text mt-3">
                  Mit dem Absenden stimmen Sie der Verarbeitung Ihrer Daten gemäß der
                  <router-link :to="{name: 'SwvDatenschutz'}" target="_blank" class="swv-link">Datenschutzerklärung</router-link> zu.
                </p>
              </template>

              <v-divider class="mt-4 mb-3" />

              <p class="body-1">
                Bei Fragen können Sie sich gerne wenden an:<br><br>
                <strong>Eric Rubas</strong><br>
                Bezirksrat<br>
                Obmann SWV-Alsergrund<br>
                <a href="tel:+436642304042" class="swv-link">0664 230 40 42</a>
              </p>

            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { API } from 'aws-amplify';

export default {
  data() {
    return {
      name: '',
      email: '',
      telefon: '',
      auswahl: null,
      loadedAt: 0,
      submitted: false,
      loading: false,
      done: false,
      error: false,
      nameRules: [
        (v) => !!v || 'Name ist ein Pflichtfeld',
      ],
      emailRules: [
        (v) => !!v || 'E-Mail ist ein Pflichtfeld',
        (v) => /.+@.+\..+/.test(v) || 'Bitte geben Sie eine gültige E-Mail Adresse an.',
      ],
    };
  },
  mounted() {
    this.loadedAt = Date.now();
  },
  methods: {
    async submit() {
      this.error = false;
      this.submitted = true;

      if (Date.now() - this.loadedAt < 1000) {
        this.done = true;
        return;
      }

      if (!this.name || !this.email || !/.+@.+\..+/.test(this.email) || !this.auswahl) {
        return;
      }

      this.loading = true;

      const auswahlLabels = {
        komme: 'Ich komme gerne zum Informationsfrühstück am 2.6.2026',
        komme_kuenftig: 'Ich komme gerne zum Informationsfrühstück am 2.6.2026 und freue mich auch künftig über Ihre Einladungen.',
        nicht_kuenftig: 'Ich kann zum Informationsfrühstück am 2.6.2026 nicht kommen, freue mich aber künftig über Ihre Einladungen.',
      };

      try {
        await API.post('eventmanagerPublicApi', '/public/swv/fruehstueck', {
          body: {
            name: this.name,
            email: this.email,
            telefon: this.telefon || '',
            auswahl: auswahlLabels[this.auswahl],
          },
        });
        this.done = true;
      } catch {
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.v-content {
  background: #fff;
}
.swv-link {
  color: #e3010f;
}
</style>
